import { atom } from "recoil";

export const accessPermissionRequestCountAtom = atom<number | null>({
  key: "accessPermissionRequestCountAtom",
  default: null,
});
